import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section className="bg-background-100">
      <div className="px-4 md:px-6 xl:px-10 py-14 md:py-20">
        <div className="max-w-[1320px] mx-auto">
          <div className="mb-10">
            <p className="text-xs tracking-[0.3em] text-primary-600 mb-2">SECTIONS</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">从这五个角度吃瓜</h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-[640px]">
              我们不追单一事件的情绪，而是把打榜这件事拆成可追踪的五个方向，方便你按兴趣深入。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {topics.map((topic, index) => (
              <Link
                key={topic.slug}
                to={`/ranking?category=${encodeURIComponent(topic.name)}`}
                className={[
                  "group flex flex-col p-6 rounded-lg border transition-colors cursor-pointer",
                  index === 0
                    ? "bg-primary-500 border-primary-500 text-background-50 md:col-span-2 lg:col-span-1"
                    : "bg-background-50 border-background-200 hover:border-primary-300",
                ].join(" ")}
              >
                <div className="flex items-start justify-between mb-5">
                  <span
                    className={[
                      "w-11 h-11 flex items-center justify-center rounded-md",
                      index === 0 ? "bg-background-50/20 text-background-50" : "bg-accent-100 text-accent-800",
                    ].join(" ")}
                  >
                    <i className={`${topic.icon} text-xl`} />
                  </span>
                  <span
                    className={[
                      "text-xs px-2 py-1 rounded",
                      index === 0 ? "bg-background-50/20 text-background-50" : "bg-secondary-100 text-secondary-900",
                    ].join(" ")}
                  >
                    {topic.count} 篇
                  </span>
                </div>
                <h3
                  className={[
                    "font-heading text-lg font-bold mb-2",
                    index === 0 ? "text-background-50" : "text-foreground-950 group-hover:text-primary-700",
                  ].join(" ")}
                >
                  {topic.name}
                </h3>
                <p
                  className={[
                    "text-sm leading-relaxed flex-1",
                    index === 0 ? "text-background-100" : "text-foreground-600",
                  ].join(" ")}
                >
                  {topic.desc}
                </p>
                <span
                  className={[
                    "mt-5 inline-flex items-center gap-1 text-xs",
                    index === 0 ? "text-background-50" : "text-primary-700",
                  ].join(" ")}
                >
                  进入栏目
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}